module.exports = __webpack_public_path__ + "img/督导中心.972a755e.png";